module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n\n<capacity-bar params=\"\n    total: ko.unwrap($data).total,\n    used: ko.unwrap($data).used\n\"></capacity-bar>\n";
